import { IField } from '@framework/ui/Organisms/FinalForm/validators/interfaces/Field';
import { IValidationError } from './interfaces/ValidationError';

export const validateRequiredFields = (
  requiredFields: IField[],
  values: { [key: string]: unknown },
  getMessage?: (fieldName: string) => string,
): IValidationError => {
  let errors: Record<string, string> = {};
  requiredFields.forEach((field) => {
    if (!values[field.fieldName]) {
      errors[field.fieldName] = getMessage?.(field.fieldName) ?? `${ field.fieldCaption || 'Field' } ${ field.isPlural && field.fieldCaption ? 'are' : 'is' } required`;
    }
  });
  return errors;
};
